import { render } from "./ConviteCard.vue?vue&type=template&id=2f84cfbd&scoped=true"
import script from "./ConviteCard.vue?vue&type=script&lang=js"
export * from "./ConviteCard.vue?vue&type=script&lang=js"

import "./ConviteCard.vue?vue&type=style&index=0&id=2f84cfbd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f84cfbd"]])

export default __exports__